class GlobalVariable {
    constructor () {
        this.baseUrl = 'https://api.govtcollegekarauli.ac.in/api';
    }
  }
  
export default (new GlobalVariable())